module.exports = __webpack_public_path__ + "static/ocr-a70e307ab871638984097ebfe4deb9b2.gif";